// Webhook form field/rule definitions, mirroring ReportFormFieldDefs:
// `types` is the array multiselect (like employeeLists) and `allTypes` is the
// "select all" checkbox that disables it (like allEmployees).

export const webhookFieldDefinitions = {
    id: {
        name: 'id',
        type: 'hidden',
        value: null,
    },

    name: {
        name: 'name',
        label: 'Name',
        placeholder: 'Webhook Name',
        rules: 'string|required',
        value: '',
    },

    url: {
        name: 'url',
        label: 'Webhook URL',
        placeholder: 'Webhook URL',
        rules: 'string|required|startsWithHttps',
        value: '',
    },

    signatureSecret: {
        name: 'signatureSecret',
        label: 'Signature Secret (strongly recommended)',
        placeholder: 'Signature Secret',
        rules: 'string',
        value: '',
    },

    types: {
        name: 'types',
        label: 'Select webhook types that will trigger this webhook',
        placeholder: 'Select from existing types',
        rules: 'array',
        value: [],
        disabled: false,
        hooks: {
            onChange(field) {
                field.state.form.validate();
            },
        },
    },

    allTypes: {
        name: 'allTypes',
        label: 'All webhook types',
        rules: 'boolean|requiredIfEmptyArray:types',
        type: 'checkbox',
        value: false,
        hooks: {
            onChange(field) {
                /** Before validating I need to make sure it isn't disabled */
                field.state.form.$('types').set('disabled', false);
                field.state.form.$('types').validate();

                /** Disable types field if 'allTypes' is checked */
                if (field.value) {
                    field.state.form.$('types').set('disabled', true);
                }
                field.state.form.validate();
            },
        },
    },

    company: {
        name: 'company',
        label: 'Company (optional)',
        rules: 'string',
        value: 'all',
    },

    enabled: {
        name: 'enabled',
        label: 'Enabled',
        rules: 'boolean',
        type: 'checkbox',
        value: true,
    },
};

export const webhookRuleDefinitions = {
    startsWithHttps: {
        function(value) {
            return typeof value === 'string' && value.startsWith('https://');
        },
        message: 'Webhook URL must start with https://',
    },

    requiredIfEmptyArray: {
        /** Rule passes if this is true or the depending array is not empty (types) */
        function(val, req) {
            req = this.getParameters();

            const arrayValue = this.validator._objectPath(
                this.validator.input,
                req[0]
            );

            const arrayIsNotEmpty =
                Array.isArray(arrayValue) && arrayValue.length > 0;

            return val || arrayIsNotEmpty;
        },
        message:
            'Either all webhook types or at least one type must be selected.',
    },
};
